import React from 'react';
import { Fade } from 'react-slideshow-image';
import { Link } from 'react-router-dom';
import  './SlideNew.css';
// import imgPetitPalais from '../../assets/petit_palais.jpg'
// import imgGalerySecond from '../../assets/largeExpo.jpg'
// import imgbg005 from '../../assets/pexels-andrew-neel-2123337.jpg'
// import bgHome004 from '../../assets/bgHome004.jpg'
import HeaderArtist from '../Artistes/ReneDaniel/pyramide.jpeg';
import HeaderArtist2 from '../../assets/header22.jpg';

import { useTranslation } from 'react-i18next';
 // ajout d'un commentaire hyper utile

const slideImages = [
    HeaderArtist,
    HeaderArtist2,
    
];

const Slideshow = () => {

  const { t } = useTranslation();

    return (
      
        <Fade easing="ease">

          <Link to='/GalerieVirtuelle'> 
            <div className="eachSlide">
              <div style={{'backgroundImage': `url(${slideImages[0]})`}}>
                  <div className=" text-white bg-dark text-center pt-5 text-decoration-none " style={{width: "700px", height: "250px" , fontSize: "40px", opacity: "0.8"}}>

                    {t('SlideNew.2')}
                    
                  </div>  
              </div>
            </div>
          </Link>

          <Link to='/GalerieVirtuelle'> 
            <div className="eachSlide">
              <div style={{'backgroundImage': `url(${slideImages[1]})`}}>

                  <span className="bg-white text-bordeaux rounded-lg border border-danger">{t('SlideNew.1')}</span>
                  
              </div>
            </div>
          </Link>
          
        </Fade>
    )
};

export default Slideshow;